import React from 'react';
import { CadreApercu } from './ApercuDocument';

/**
 * Aperçu du contrat d'abonnement signé — même composant que DevisSigneApercuPrestation.tsx, mais pour
 * GET /subscriptions/:id/signed-document (2026-09-26, demande d'Emeni : « pas d'aperçu du contrat signé
 * depuis le compte client », et le même trou existait côté établissement, en Suivi de prestation comme
 * dans Abonnements — rien ne restait consultable une fois l'abonnement passé « actif »).
 */
export function ContratSigneApercuPrestation({ subscriptionId, fileName }: { subscriptionId: string; fileName?: string }) {
    const [chargement, setChargement] = React.useState(true);
    const [erreur, setErreur] = React.useState('');
    const [url, setUrl] = React.useState('');

    React.useEffect(() => {
        let annule = false;
        const token = localStorage.getItem('token');
        fetch(`/api/subscriptions/${subscriptionId}/signed-document`, { headers: { Authorization: `Bearer ${token}` } })
            .then((res) => { if (!res.ok) throw new Error('Document introuvable.'); return res.blob(); })
            .then((blob) => { if (!annule) setUrl(URL.createObjectURL(blob)); })
            .catch((e: any) => { if (!annule) setErreur(e?.message || "L'aperçu n'a pas pu être chargé."); })
            .finally(() => { if (!annule) setChargement(false); });
        return () => { annule = true; if (url) URL.revokeObjectURL(url); };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- ne recharger que si l'abonnement change
    }, [subscriptionId]);

    return (
        <CadreApercu
            titre={fileName || 'contrat-signe.pdf'}
            url={url}
            estImage={false}
            chargement={chargement}
            erreur={erreur}
        />
    );
}
